import axiosApi from "../axiosInstance";
import { getReduxCompany } from "../../helper/sessionHelper";

const getDepartmentList = async () => {
    try {
        const response = await axiosApi.get(`Department/GetDepartmentList`);
        return response?.data;
    } catch (error) {
        console.log("Error getDepartmentList===>:", error);
    }
};

const addDepartment = async (body) => {
    try {
        const response = await axiosApi.post(`Department/CreateDepartment`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addDepartment ===>", error);
    }
};

export async function getDepartmentDropdown(request) {
    try {
        request = request || {};
        request.companyId = getReduxCompany()?.companyId || 0;

        request = request ?? { "departmentId": 0, "isActive": null };
        const response = await axiosApi.post(`/department/GetDepartmentDropdownV2`, request);
        return response?.data;
    } catch (error) {
        console.log("Error getUserDropdown===>:", error);
        return null;
    }
};

export async function getDepartmentByUserId(userId) {
    try {
        const response = await axiosApi.post(`/department/getDepartmentByUserId/` + userId);
        return response?.data;
    } catch (error) {
        console.log("Error getUserDropdown===>:", error);
        return null;
    }
};

export async function getDepartmentByProjectId(projectId) {
    try {
        const response = await axiosApi.post(`/department/GetDepartmentByProjectId/` + projectId);
        return response?.data;
    } catch (error) {
        console.log("Error getUserDropdown===>:", error);
        return null;
    }
};

export const DepartmentService = {
    getDepartmentDropdown,
    getDepartmentByUserId,
    getDepartmentByProjectId,
    getDepartmentList,
    addDepartment
}